import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Grid,
  Flex,
  Icon,
  Text,
  Select,
  Divider,
  useToast,
  InputGroup,
  InputRightElement,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import { FaUser, FaList } from "react-icons/fa";
import axios from "axios";
import { TeacherContext } from "../../Context/TeacherContext";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const StaffForm = () => {
  const navigate = useNavigate();

  const { refreshTeachers } = useContext(TeacherContext);
  const [showPreview, setShowPreview] = useState(false);

  const toast = useToast();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    date_of_birth: "",
    address: "",
    contact_no: "",
    nation: "",
    state: "",
    district: "",
    place: "",
    gender: "",
    blood_group: "",
    date_of_join: "",
    aadhar_no: "",
    image: "",
    guardian_name: "",
    relation: "",
    guardian_contact_no: "",
    guardian_address: "",
    username: "",
    password: "",
    confirm_password: "", // Added for confirm password
  });

  const [nations, setNations] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [bloodGroups, setBloodGroups] = useState([]);
  const [genders, setGenders] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/staff/nation_master.php`)
      .then((response) => setNations(response.data.data || []))
      .catch((error) => console.error("Error fetching nations:", error));

    axios
      .get(`${BASE_URL}/admin/staff/blood_group_master.php`)
      .then((response) => setBloodGroups(response.data.data || []))
      .catch((error) => console.error("Error fetching blood groups:", error));

    axios
      .get(`${BASE_URL}/admin/staff/gender_master.php`)
      .then((response) => setGenders(response.data.data || []))
      .catch((error) => console.error("Error fetching genders:", error));
  }, []);

  const handleNationChange = (e) => {
    const selectedNationId = e.target.value;
    setFormData((prevState) => ({ ...prevState, nation: selectedNationId }));

    // Clear state and districts when nation changes
    setStates([]);
    setDistricts([]);

    // Fetch states for the selected nation
    axios
      .get(`${BASE_URL}/admin/staff/state_master.php`)
      .then((response) => {
        const filteredStates = response.data.data.filter(
          (state) => state.nation_id === selectedNationId
        );
        setStates(filteredStates);
      })
      .catch((error) => console.error("Error fetching states:", error));
  };
  const handlePreview = () => {
    setShowPreview(true); // Display the preview modal
  };
  const handleStateChange = (e) => {
    const selectedStateId = e.target.value;
    setFormData((prevState) => ({ ...prevState, state: selectedStateId }));

    // Fetch districts for the selected state using POST request
    axios
      .post(
        `${BASE_URL}/admin/staff/district_master.php`,
        { state_id: selectedStateId }, // Send state_id in the request body
        {
          headers: {
            "Content-Type": "application/json", // Ensure the correct headers
          },
        }
      )
      .then((response) => {
        if (response.data && response.data.data) {
          setDistricts(response.data.data); // Set districts for the selected state
        } else {
          setDistricts([]); // Clear districts if no data is found
          console.error("No districts data found for the selected state");
        }
      })
      .catch((error) => console.error("Error fetching districts:", error));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setFormData({
        ...formData,
        image: reader.result, // Base64 string
      });
    };
  };
  const validateEmail = (email) => {
    if (!email) return true; // allow empty
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    if (!validateEmail(formData.email)) {
      toast({
        title: "Error",
        description: "Please enter a valid email address",
        status: "error",
        duration: 5000,
        isClosable: true,
      });

      return;
    }
    if (formData.password !== formData.confirm_password) {
      toast({
        title: "Error",
        description: "Passwords do not match!",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    try {
      const data = {
        ...formData,
        school_id: sessionStorage.getItem("school_id"),
        pass: sessionStorage.getItem("user_id"),
      };

      console.log(data);

      const response = await axios.post(
        `${BASE_URL}/admin/staff/create_staff.php`,
        data
      );
      console.log("Response:", response.data);

      if (response.data.success) {
        toast({
          title: "Success",
          description: "Data submitted successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        refreshTeachers();
        // Optionally clear the form here
        setFormData({
          name: "",
          email: "",
          date_of_birth: "",
          address: "",
          contact_no: "",
          nation: "",
          state: "",
          district: "",
          place: "",
          gender: "",
          blood_group: "",
          date_of_join: "",
          aadhar_no: "",
          image: "",
          guardian_name: "",
          relation: "",
          guardian_contact_no: "",
          guardian_address: "",
          username: "",
          password: "",
          confirm_password: "",
        });
      } else {
        toast({
          title: "Error",
          description: response.data.message || "Failed to submit data!",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message
      );
      toast({
        title: "Error",
        description: "There was an error submitting the data.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  const handleClick = () => {
    navigate("/teachers/all"); // Navigate to the desired route
  };
  return (
    <Box borderRadius="md" mx="auto">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px" }}>Add Teacher</h1>
            <div className="action-buttons">
              <Button
                className="add-teacher-button"
                onClick={handleClick}
                leftIcon={<FaList />}
                colorScheme="teal" // Optional: You can customize the color scheme
              >
                <Box display={{ base: "none", md: "block" }}>Teachers</Box>
              </Button>

              {/* <div className="export-dropdown">
                                <Button className="export-button" backgroundColor='white' fontSize='11px' boxShadow="md">
                                    <FaPrint color='#515B73' />
                                    Print PDF
                                </Button>
                            </div> */}
            </div>
          </div>

          <div className="breadcrumb">
            <span>Admin</span> / <span>Teachers</span> /{" "}
            <span>Add Teachers </span>
          </div>
        </div>
        <VStack
          spacing={4}
          p={6}
          align="stretch"
          as="form"
            onSubmit={handleSubmit}
        >
          {/* Personal Information Section */}
          <Box width="100%" bg="#F2F5FF" p={1} borderRadius="md">
            <Flex align="center" mb={4} mt={2} ml={2}>
              <Icon as={FaUser} boxSize={6} color="teal" mr={2} />
              <Text fontSize="lg" fontWeight="bold">
                Personal Information
              </Text>
            </Flex>
          </Box>
          <Grid
            templateColumns={{ base: "1fr", lg: "repeat(5, 1fr)" }}
            gap={6}
            mb={6}
            p={2}
          >
            <FormControl id="name" isRequired>
              <FormLabel>Name</FormLabel>
              <Input
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Name"
              />
            </FormControl>

            <FormControl id="email" isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email"
              />
            </FormControl>

            <FormControl id="date_of_birth" isRequired>
              <FormLabel>Date of Birth</FormLabel>
              <Input
                type="date"
                name="date_of_birth"
                value={formData.date_of_birth}
                onChange={handleInputChange}
              />
            </FormControl>

            <FormControl id="address" isRequired>
              <FormLabel>Address</FormLabel>
              <Input
                value={formData.address}
                name="address"
                onChange={handleInputChange}
                placeholder="Address"
              />
            </FormControl>

            <FormControl id="contact_no" isRequired>
              <FormLabel>Contact No</FormLabel>
              <Input
                value={formData.contact_no}
                name="contact_no"
                onChange={handleInputChange}
                placeholder="Contact No"
              />
            </FormControl>
          </Grid>

          <Divider borderColor="gray.300" borderStyle="dotted" />

          {/* Address Information Section */}
          <Box>
            <Grid
              templateColumns={{ base: "1fr", lg: "repeat(5, 1fr)" }}
              gap={6}
              mb={6}
              p={2}
            >
              <FormControl id="nation_id" isRequired>
                <FormLabel>Nation</FormLabel>
                <Select
                  value={formData.nation}
                  name="nation"
                  onChange={handleNationChange}
                  placeholder="Select Nation"
                >
                  {nations.map((nation) => (
                    <option key={nation.id} value={nation.id}>
                      {nation.nation}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {formData.nation && (
                <FormControl id="state_id" isRequired>
                  <FormLabel>State</FormLabel>
                  <Select
                    value={formData.state}
                    name="state"
                    onChange={handleStateChange}
                    placeholder="Select State"
                  >
                    {states.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.state}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}

              {formData.state && (
                <FormControl id="district_id" isRequired>
                  <FormLabel>District</FormLabel>
                  <Select
                    value={formData.district}
                    name="district"
                    onChange={handleInputChange}
                    placeholder="Select District"
                  >
                    {districts.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.district}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}

              <FormControl id="place" isRequired>
                <FormLabel>Place</FormLabel>
                <Input
                  value={formData.place}
                  name="place"
                  onChange={handleInputChange}
                  placeholder="Place"
                />
              </FormControl>

              <FormControl id="gender" isRequired>
                <FormLabel>Gender</FormLabel>
                <Select
                  value={formData.gender}
                  name="gender"
                  onChange={handleInputChange}
                  placeholder="Select Gender"
                >
                  {genders.map((gender) => (
                    <option key={gender.id} value={gender.id}>
                      {gender.gender}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid
              templateColumns={{ base: "1fr", lg: "repeat(5, 1fr)" }}
              gap={6}
              mb={6}
              p={2}
            >
              <FormControl id="blood_group" isRequired>
                <FormLabel>Blood Group</FormLabel>
                <Select
                  value={formData.blood_group}
                  name="blood_group"
                  onChange={handleInputChange}
                  placeholder="Select Blood Group"
                >
                  {bloodGroups.map((bloodGroup) => (
                    <option key={bloodGroup.id} value={bloodGroup.id}>
                      {bloodGroup.group}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl id="date_of_join" isRequired>
                <FormLabel>Date of Join</FormLabel>
                <Input
                  type="date"
                  name="date_of_join"
                  value={formData.date_of_join}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl id="aadhar_no" isRequired>
                <FormLabel>Aadhar No</FormLabel>
                <Input
                  value={formData.aadhar_no}
                  name="aadhar_no"
                  onChange={handleInputChange}
                  placeholder="Aadhar No"
                />
              </FormControl>

              <FormControl id="image">
                <FormLabel>Profile Image</FormLabel>
                <Input type="file" onChange={handleFileChange} />
              </FormControl>

              <FormControl id="guardian_name" isRequired>
                <FormLabel>Guardian Name</FormLabel>
                <Input
                  value={formData.guardian_name}
                  name="guardian_name"
                  onChange={handleInputChange}
                  placeholder="Guardian Name"
                />
              </FormControl>

              <FormControl id="relation" isRequired>
                <FormLabel>Relation</FormLabel>
                <Input
                  value={formData.relation}
                  name="relation"
                  onChange={handleInputChange}
                  placeholder="Relation"
                />
              </FormControl>

              <FormControl id="guardian_contact_no" isRequired>
                <FormLabel>Guardian Contact No</FormLabel>
                <Input
                  value={formData.guardian_contact_no}
                  name="guardian_contact_no"
                  onChange={handleInputChange}
                  placeholder="Guardian Contact No"
                />
              </FormControl>

              <FormControl id="guardian_address" isRequired>
                <FormLabel>Guardian Address</FormLabel>
                <Input
                  value={formData.guardian_address}
                  name="guardian_address"
                  onChange={handleInputChange}
                  placeholder="Guardian Address"
                />
              </FormControl>
            </Grid>

            <Divider borderColor="gray.300" borderStyle="dotted" />

            <Grid
              templateColumns={{ base: "1fr", lg: "repeat(5, 1fr)" }}
              gap={6}
              mb={6}
              p={2}
            >
              <FormControl id="username" isRequired>
                <FormLabel>Username</FormLabel>
                <Input
                  value={formData.username}
                  name="username"
                  onChange={handleInputChange}
                  placeholder="Username"
                />
              </FormControl>

              <FormControl id="password" isRequired>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  value={formData.password}
                  name="password"
                  onChange={handleInputChange}
                  placeholder="Password"
                />
              </FormControl>

              <FormControl id="confirm_password" isRequired>
                <FormLabel>Confirm Password</FormLabel>
                <Input
                  type="password"
                  value={formData.confirm_password}
                  name="confirm_password"
                  onChange={handleInputChange}
                  placeholder="Confirm Password"
                />
              </FormControl>
            </Grid>
          </Box>

          <Button colorScheme="teal" type="submit">
            Submit
          </Button>

          <Button
            colorScheme="teal"
            onClick={handlePreview}
            size="md" // Small button size
            ml="auto" // Align to the right side of the container
          >
            Preview
          </Button>

          {/* Preview Modal */}
          {/* Preview Modal */}
          {showPreview && (
            <Modal
              isOpen={showPreview}
              onClose={() => setShowPreview(false)}
              size="lg"
              motionPreset="slideInBottom"
            >
              <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
              <ModalContent
                borderRadius="lg"
                boxShadow="xl"
                bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
                color="gray.700"
                p={6}
                maxW="700px"
                maxH="550px"
                overflowY="auto"
              >
                <ModalHeader
                  fontSize="xl"
                  fontWeight="bold"
                  textAlign="center"
                  color="teal.600"
                >
                  Preview for Add Teacher
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody
                  overflowY="auto"
                  px={4}
                  css={{
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "rgba(255, 255, 255, 0.2)",
                      borderRadius: "10px",
                      backdropFilter: "blur(8px)",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "rgba(173, 216, 230, 0.6)",
                      borderRadius: "10px",
                      backdropFilter: "blur(8px)",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "rgba(173, 216, 230, 0.9)",
                    },
                  }}
                >
                  <Box overflowY="auto" maxHeight="600px" p={4}>
                    <Grid
                      templateColumns={{
                        base: "1fr",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(2, 1fr)",
                      }}
                      gap={4}
                    >
                      {/* Personal Information Fields */}
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Name:
                          </Text>
                          <Text>{formData.name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Email:
                          </Text>
                          <Text>{formData.email}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Address:
                          </Text>
                          <Text>{formData.address}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Date of Birth:
                          </Text>
                          <Text>{formData.date_of_birth}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Gender:
                          </Text>
                          <Text>{formData.gender}</Text>
                        </Flex>
                      </Box>

                      {/* Add Nation, State, and District */}
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Nation:
                          </Text>
                          <Text>
                            {
                              nations.find(
                                (nation) => nation.id === formData.nation
                              )?.nation
                            }
                          </Text>
                        </Flex>
                      </Box>
                      {formData.nation && (
                        <Box whiteSpace="nowrap" minW="300px">
                          <Flex align="center">
                            <Text fontWeight="semibold" minW="120px">
                              State:
                            </Text>
                            <Text>
                              {
                                states.find(
                                  (state) => state.id === formData.state
                                )?.state
                              }
                            </Text>
                          </Flex>
                        </Box>
                      )}
                      {formData.state && (
                        <Box whiteSpace="nowrap" minW="300px">
                          <Flex align="center">
                            <Text fontWeight="semibold" minW="120px">
                              District:
                            </Text>
                            <Text>
                              {
                                districts.find(
                                  (district) =>
                                    district.id === formData.district
                                )?.district
                              }
                            </Text>
                          </Flex>
                        </Box>
                      )}

                      {/* Add new fields */}
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Place:
                          </Text>
                          <Text>{formData.place}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Contact No:
                          </Text>
                          <Text>{formData.contact_no}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Blood Group:
                          </Text>
                          <Text>{formData.blood_group}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Date of Joining:
                          </Text>
                          <Text>{formData.date_of_join}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Guardian Name:
                          </Text>
                          <Text>{formData.guardian_name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Guardian Relation:
                          </Text>
                          <Text>{formData.relation}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Guardian Contact No:
                          </Text>
                          <Text>{formData.guardian_contact_no}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Guardian Address:
                          </Text>
                          <Text>{formData.guardian_address}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Username:
                          </Text>
                          <Text>{formData.username}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Password:
                          </Text>
                          <Text>{formData.password}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Confirm Password:
                          </Text>
                          <Text>{formData.confirm_password}</Text>
                        </Flex>
                      </Box>
                    </Grid>

                    <Divider
                      my={6}
                      borderColor="gray.300"
                      borderStyle="dotted"
                    />

                    {/* Additional Information Fields */}
                    <Grid
                      templateColumns={{
                        base: "1fr",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(3, 1fr)",
                      }}
                      gap={8}
                    >
                      {/* Continue with other fields as required */}
                    </Grid>
                  </Box>

                  <ModalFooter>
                    <Button colorScheme="teal" mr={3} onClick={handleSubmit}>
                      Proceed & Submit
                    </Button>
                    <Button
                      variant="ghost"
                      onClick={() => setShowPreview(false)}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalBody>
              </ModalContent>
            </Modal>
          )}
        </VStack>
      </div>
    </Box>
  );
};

export default StaffForm;
